import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ProductMeasurementType from '../../models/ProductMeasurementType';


export interface ProductMeasurementTypeDetailState extends ApiState {
  productMeasurementType?: ProductMeasurementType
}

export default requestReducer<ProductMeasurementTypeDetailState>('PRODUCTMEASUREMENTTYPE_DETAIL')
